import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Header from './component/header'
import Home from './pages/home/index'
import WhatsAppIcon from './component/whatsapp/index';
import Products from "./pages/products/index";
import ReactGA from 'react-ga';
import Aboutus from "./pages/aboutus";
import Contact from "./pages/contact";
const TRACKING_ID = "G-RY4FXVLWHL"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
function App() {
  return (
    <>
      <Header />
      <WhatsAppIcon />
      <Router>
        <Routes>
          <Route exact path='/' element={<Home/>}></Route>
          <Route exact path='/product/:id' element={<Products/>}></Route>
          <Route exact path='/about-us' element={<Aboutus/>}></Route>
          <Route exact path='/contact' element={<Contact/>}></Route>
          <Route path="*" element={<h1>404 - Page Not Found</h1>} /> {/* Handle unmatched routes */}
        </Routes>
      </Router>
    </>
  );
}

export default App;